import { useContext, useMemo } from 'react'
import { useParams, Navigate } from "react-router-dom"

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import Summary from '/components/templates/summary'

import HelpText from '/help/template-details'
import Menu from '/components/templates/template-nav-menu'

const TemplateDetails = () => {

  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  if (!loadingTemplates && !template) return <Navigate to="/templates" replace />

  if (template) return (
    <PageWrapper title={template ? `Template Details (${template.name})` : 'Template Details'} HelpText={HelpText} heading={heading} selectedTemplate={template} menu={<Menu template={template} />}>
      <div className='h-full w-full max-w-full overflow-y-auto pb-10'>
        <Summary template={template} scannerDetailsAside />
      </div>
    </PageWrapper>
  )
}

export default TemplateDetails
